import withAnalyticsEvents from '@atlaskit/analytics-next/withAnalyticsEvents';
import withAnalyticsContext from '@atlaskit/analytics-next/withAnalyticsContext';
import AnnouncementBannerComponent from './announcement-banner';

export default withAnalyticsContext({ componentName: 'banner' })(
	withAnalyticsEvents()(AnnouncementBannerComponent),
);
